import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const userName = sessionStorage.getItem("user_name");
  const logout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true });
  };
  return (
    <nav className="navbar fixed-top">
        <div className="d-flex align-items-center navbar-left">
            <span style={{fontSize: 24, textTransform: 'uppercase', padding: '0px 30px', fontWeight: 500}}>
              <img src={"/assets/img/logoMg.png"} className="img-fluid logo" alt="My Godowns" style={{ width: 80, height: 48 }} />
            </span>
        </div>

        <Link to={'#'} className="navbar-logo" style={{fontWeight: 500, fontSize: 24}}>
          {userName}
        </Link>

        <div className="navbar-right">
            <div className="header-icons d-inline-block align-middle">
                <button className="header-icon btn btn-empty d-none d-sm-inline-block" type="button" onClick={logout}>
                    <i style={{fontSize: 24}} className="simple-icon-power"></i>
                </button>
            </div>
        </div>
    </nav>
  );
};

export default Header;
